import React from 'react';
import styled from 'styled-components';
import { withMetrics } from '@catalogo/core-metrics';
import CollapseText from '@catalogo/theme-collapse-text';

export const AnswerBox = ({ answer, dispatchMetrics }) => {
  const metricContent = {
    category: 'product',
    action: 'Q&A - Collapse Text',
  };

  const textCollpaseMetrics = collapseActive => {
    const label = collapseActive ? 'ver mais' : 'ver menos';
    dispatchMetrics('event:track', { ...metricContent, label });
  };

  return (
    <Wrapper>
      <Answer>
        <CollapseText text={answer.text} maxTextLength={310} defaultTextHeight={63} onChange={textCollpaseMetrics} />
      </Answer>
      <AnswerOwner>respondido por {answer.owner}</AnswerOwner>
      <AnswerCreatedAt>{answer.createdAt}</AnswerCreatedAt>
    </Wrapper>
  );
};

export default withMetrics(AnswerBox);

const Wrapper = styled.div`
  position: relative;
  padding: 15px 25px;
  background: #f8f8f8;
  margin: 10px 0 0 10px;

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: -8px;
    width: 3px;
    height: 100%;
    background: #666;
  }
`;

const Answer = styled.p`
  font-size: 14px;
  word-break: break-word;
  color: #838383;
`;

const AnswerCreatedAt = styled.span`
  color: #c4c4c4;
  font-size: 13px;
`;

const AnswerOwner = styled.p`
  margin-top: 10px;
  font-size: 13px;
  color: #c4c4c4;
`;
